import React from 'react'
import PropTypes from 'prop-types'
import './Tabs.css';

const Tabs = ({tabs, onTabSelected, selected}) => {

  const tabsList = tabs.map((tab, key) =>
    <li key={key} className={"nav-link " + (selected === tab.key ? 'active' : '')}>
      <a onClick={() => onTabSelected(tab.key)}>
        <span className="nav-label">{tab.value}</span>
      </a>
    </li>
  );

  return (
    <ul className="nav" id="side-menu">
      {tabsList}
    </ul>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.array,
  selected: PropTypes.string,
  onTabSelected: PropTypes.func
};

export default Tabs;


// WEBPACK FOOTER //
// ./src/tabs/Tabs.js